import { Button } from '@/components/Button'
import {
  ModalSheet,
  ModalSheetContent,
  ModalSheetFooter,
  ModalSheetFooterButtonGroup,
  ModalSheetFooterSpacer,
  ModalSheetHeader,
  ModalSheetTitle,
} from '@/components/ModalSheet'
import styles from './UserInfoItemListDialog.module.css'

export interface UserInfoItemListDialogItem {
  value: string
  /**
   * The value as used in test ids.
   */
  normalizedValue: string
}

export interface UserInfoItemListDialogProps {
  showing: boolean
  onClose: () => void
  title: string
  /**
   * The title as used in test ids.
   */
  normalizedTitle: string
  items: UserInfoItemListDialogItem[]
}

export function UserInfoItemListDialog({
  showing,
  onClose,
  title,
  normalizedTitle,
  items,
}: UserInfoItemListDialogProps) {
  return (
    <ModalSheet showing={showing} onRequestClose={onClose}>
      <ModalSheetHeader bordered withCloseButton>
        <ModalSheetTitle>
          {title}
          <span className={styles.titleSubtext}>{` (${items.length})`}</span>
        </ModalSheetTitle>
      </ModalSheetHeader>
      <ModalSheetContent>
        {items.map((item, index) => (
          <UserInfoItem
            key={index}
            item={item.value}
            testId={`user-info-item-${normalizedTitle}-${item.normalizedValue}-value`}
          />
        ))}
      </ModalSheetContent>
      <ModalSheetFooter>
        <ModalSheetFooterSpacer />
        <ModalSheetFooterButtonGroup>
          <Button
            label="Close"
            variant="default"
            onPress={onClose}
            testId={`user-details-pro-information-${normalizedTitle}-close-button`}
          />
        </ModalSheetFooterButtonGroup>
      </ModalSheetFooter>
    </ModalSheet>
  )
}

interface UserInfoItemProps {
  item: string
  testId?: string
}

function UserInfoItem({ item, testId }: UserInfoItemProps) {
  return (
    <div className={styles.userInfoItem}>
      <span className={styles.userInfoItemName} data-test={testId}>
        {item}
      </span>
    </div>
  )
}
